/**
 * DeleteJobForm
 */
import React from 'react';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import { Form, Button, Grid, Message } from 'semantic-ui-react';

// Components
// @ts-ignore
import SubmittingButton from '../../../../../../../../components/SubmittingButton';

// Actions
// @ts-ignore
import { deleteDocumentSet } from '../../../../../../../../services/documentSets/actions';

interface Props {
    documentSetId: number;
    deleteDocumentSet: Function;
    error?: string;
    handleSubmit: Function;
    onClose: Function;
}

export class DeleteJobForm extends React.PureComponent<Props> {
    handleSubmit = () => {
        const { documentSetId } = this.props;
        this.props.deleteDocumentSet(documentSetId);
    };

    render(): React.ReactElement {
        const { error, handleSubmit, onClose } = this.props;

        return (
            <Form
                onSubmit={handleSubmit(this.handleSubmit)}
                autoComplete="off"
            >
                {error && <Message negative>{error}</Message>}
                <Grid>
                    <Grid.Column mobile={16} tablet={8} computer={8}>
                        <Button
                            type="button"
                            onClick={() => onClose()}
                            fluid
                            basic
                            primary
                        >
                            Cancel
                        </Button>
                    </Grid.Column>
                    <Grid.Column mobile={16} tablet={8} computer={8}>
                        <SubmittingButton
                            type="submit"
                            namespace="DOCUMENT_SET_DELETE"
                            negative
                            fluid
                        >
                            Delete
                        </SubmittingButton>
                    </Grid.Column>
                </Grid>
            </Form>
        );
    }
}

export default connect(
    null,
    { deleteDocumentSet }
)(
    reduxForm<any, any>({
        form: 'DOCUMENT_SET_DELETE'
    })(DeleteJobForm)
);
